module.exports = __webpack_public_path__ + "static/media/badge-i-os.6d1ba04b.png";